import { OnInit, OnDestroy, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { BookmarkModel } from '../../models/bookmark.model';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Store, Actions, ofActionDispatched } from '@ngxs/store';
import { DeleteBookmark, DeleteBookmarkSuccess, DeleteBookmarkFail, DeleteFavoriteSuccess, DeleteFavoriteFail, DeleteFavorite, CopyBookmark, CopyBookmarkSuccess, CopyBookmarkFailure } from '../../state/bookmarks.actions';
import { PublishDialogComponent } from 'src/app/publish/components/publish-dialog/publish-dialog.component';
import { GetPublishURLSuccess, GetPublishURL, GetPublishURLFail } from 'src/app/publish/state/publish.actions';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { filter, takeUntil, flatMap } from 'rxjs/operators';
import { Subject, of, BehaviorSubject } from 'rxjs';
import { ClipboardService } from 'src/app/shared/clipboard.service';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { DialogService } from 'src/app/dialogs/dialog.service';
import * as _ from 'lodash';
import { PublishState } from 'src/app/publish/state/publish.state';
import { BookmarksService } from '../../bookmarks.service';
import { ExploreService } from 'src/app/explore/explore.service';
export var BookmarkActionsEnum;
(function (BookmarkActionsEnum) {
    BookmarkActionsEnum["View"] = "view";
    BookmarkActionsEnum["Edit"] = "edit";
    BookmarkActionsEnum["Manage"] = "manage";
    BookmarkActionsEnum["Embed"] = "embed";
    BookmarkActionsEnum["Delete"] = "delete";
    BookmarkActionsEnum["CopyLink"] = "copy-link";
    BookmarkActionsEnum["CopyBookmark"] = "copy-bookmark";
    BookmarkActionsEnum["CopyTeamBookmark"] = "copy-team-bookmark";
})(BookmarkActionsEnum || (BookmarkActionsEnum = {}));
var BookmarkActionsComponent = /** @class */ (function () {
    function BookmarkActionsComponent(dialog, dialogService, store, actions, snackbar, clipboardService, bookmarksService, exploreService, changeDetectorRef) {
        this.dialog = dialog;
        this.dialogService = dialogService;
        this.store = store;
        this.actions = actions;
        this.snackbar = snackbar;
        this.clipboardService = clipboardService;
        this.bookmarksService = bookmarksService;
        this.exploreService = exploreService;
        this.changeDetectorRef = changeDetectorRef;
        this.bookmarkActionsEnum = BookmarkActionsEnum;
        this.bookmarkSubject = new BehaviorSubject(null);
        this.bookmarkType = StoryType.Module;
        this.bookmarkEmbedTypes = [StoryType.Bookmark];
        this.theme = 'dark';
        this.bookmarkActions = [
            BookmarkActionsEnum.View,
            BookmarkActionsEnum.Edit,
            BookmarkActionsEnum.Manage,
            BookmarkActionsEnum.Embed,
            BookmarkActionsEnum.Delete,
            BookmarkActionsEnum.CopyLink
        ];
        this.otherActions = [];
        this.otherClick = new EventEmitter();
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(BookmarkActionsComponent.prototype, "bookmark", {
        get: function () {
            return this._bookmark;
        },
        set: function (value) {
            if (value == null) {
                return;
            }
            this.bookmarkSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    BookmarkActionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bookmarkSubject
            .pipe(filter(function (bookmark) {
            return bookmark != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (bookmark) {
            _this._bookmark = bookmark;
            _this.bookmarkId = bookmark.id;
            _this.bindApplicationEvents();
            _this.changeDetectorRef.markForCheck();
        });
    };
    BookmarkActionsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    BookmarkActionsComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        // handle delete bookmark/favorite
        this.actions
            .pipe(ofActionDispatched(DeleteBookmarkSuccess, DeleteFavoriteSuccess), filter(function (action) { return action.bookmarkId === _this.bookmark.id; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.handleDeleteSuccess();
        });
        this.actions
            .pipe(ofActionDispatched(DeleteBookmarkFail, DeleteFavoriteFail), filter(function (action) { return action.bookmarkId === _this.bookmark.id; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.handleDeleteFailure();
        });
        // Copy generated link to clipboard
        this.actions
            .pipe(ofActionDispatched(GetPublishURLSuccess), filter(function () { return !_this.store.selectSnapshot(PublishState.getPublishing); }), filter(function (action) { return action.model.id === _this.bookmark.id; }), flatMap(function (response) { return _this.copyToClipboard(response.url); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (copied) {
            _this.snackbar.open(copied ? 'Successfully copied link to clipboard.' : 'Unable to copy link to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishURLFail), filter(function (action) { return action.model.id === _this.bookmark.id; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackbar.open('Unable to generate URL.');
        });
        this.actions
            .pipe(ofActionDispatched(CopyBookmarkSuccess), filter(function (action) { return action.sourceId === _this.bookmark.id; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            _this.handleCopySuccess(e);
        });
        this.actions
            .pipe(ofActionDispatched(CopyBookmarkFailure), filter(function (action) { return action.id === _this.bookmark.id; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleCopyFailure(action.error);
        });
    };
    BookmarkActionsComponent.prototype.handleDeleteSuccess = function () {
        this.snackbar.open('Successfully deleted 3D model');
    };
    BookmarkActionsComponent.prototype.handleDeleteFailure = function () {
        this.snackbar.open('There was an error deleting the 3D model');
    };
    BookmarkActionsComponent.prototype.handleManageClick = function () {
        this.dialogService.openManageDialog(this.bookmark);
    };
    BookmarkActionsComponent.prototype.handleMenuOpened = function () {
        var _this = this;
        if (!this.bookmarkSubject.value) {
            if (this.bookmarkType === StoryType.Module) {
                this.exploreService.getConditionModel(this.bookmarkId)
                    .subscribe(function (bookmark) {
                    _this.bookmarkSubject.next(bookmark);
                    _this.bookmarkSubject.complete();
                });
            }
            else {
                this.bookmarksService.getBookmarkModel(this.bookmarkId)
                    .subscribe(function (bookmark) {
                    _this.bookmarkSubject.next(bookmark);
                    _this.bookmarkSubject.complete();
                });
            }
        }
    };
    BookmarkActionsComponent.prototype.handleDeleteClick = function () {
        this.delete();
    };
    BookmarkActionsComponent.prototype.handleCopySuccess = function (_a) {
        var groupAccess = _a.groupAccess, collection = _a.collection;
        var title = this.bookmark.title;
        if (collection) { // copied to collection
            this.snackbar.open(title + " was successfully added to the \"" + collection.collection_name + "\" collection.");
        }
        else if (groupAccess) { // copied to group
            this.snackbar.open(title + " was successfully added to Team Models.");
        }
        else { // default
            this.snackbar.open(title + " was successfully added to My Models");
        }
    };
    BookmarkActionsComponent.prototype.handleCopyFailure = function (error) {
        var _this = this;
        var message = _.get(error, 'error.error.message');
        switch (message) {
            case 'Action forbidden.  Your account content limit has been reached':
                var dialog$ = this.dialogService.openLimitDialog();
                dialog$.afterClosed()
                    .subscribe(function (result) {
                    if (result) {
                        _this.dialogService.openUpgradeDialog();
                    }
                });
                break;
            default:
                this.snackbar.open('There was an error adding to My Models');
        }
    };
    BookmarkActionsComponent.prototype.handleEmbedModel = function () {
        this.dialog.open(PublishDialogComponent, {
            width: '90vw',
            height: '95vh',
            data: {
                bookmark: this.bookmark
            }
        });
    };
    BookmarkActionsComponent.prototype.handleCopyLinkClick = function () {
        this.copyLink();
    };
    BookmarkActionsComponent.prototype.handleCopyBookmarkClick = function () {
        this.copyBookmark();
    };
    BookmarkActionsComponent.prototype.handleAddTeamModelClick = function () {
        this.dialogService.openAddTeamModelDialog(this.bookmark);
    };
    BookmarkActionsComponent.prototype.handleOtherClick = function (action) {
        this.otherClick.emit(action);
    };
    BookmarkActionsComponent.prototype.copyToClipboard = function (copyText) {
        var _this = this;
        return this.clipboardService.copyToClipboard(copyText)
            .pipe(flatMap(function (copied) {
            if (copied) {
                return of(copied);
            }
            else {
                return _this.dialogService.openClipboardDialog(copyText)
                    .afterClosed();
            }
        }));
    };
    BookmarkActionsComponent.prototype.hasActions = function () {
        var _this = this;
        var actions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            actions[_i] = arguments[_i];
        }
        return actions.some(function (action) { return _this.hasAction(action); });
    };
    BookmarkActionsComponent.prototype.hasAction = function (action) {
        var enabled = this.bookmarkActions.some(function (_action) { return _action === action; });
        if (enabled) { // handle secondary validation
            switch (action) {
                case BookmarkActionsEnum.Delete:
                    return (this.bookmark && this.bookmark.is_owner) || this.bookmark.favorite;
                case BookmarkActionsEnum.Embed:
                    return this.bookmarkEmbedTypes.includes(this.bookmarkType);
                case BookmarkActionsEnum.CopyBookmark:
                    return this.bookmark && !this.bookmark.is_owner && !this.bookmark.favorite && !this.bookmark.unavailable;
                default:
                    return enabled;
            }
        }
        else {
            return enabled;
        }
    };
    BookmarkActionsComponent.prototype.delete = function () {
        var _this = this;
        var dialogRef = this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Delete 3D model',
                bodyText: 'Are you sure you want to delete this 3D model?',
                confirmText: 'Delete',
                confirmColor: 'warn'
            }
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (confirmed) {
            if (confirmed) {
                // special case: favorites
                var isFavorite = _this.bookmark.favorite;
                if (isFavorite) {
                    _this.store.dispatch(new DeleteFavorite(_this.bookmark));
                }
                else {
                    _this.store.dispatch(new DeleteBookmark(_this.bookmarkId));
                }
            }
        });
    };
    BookmarkActionsComponent.prototype.copyLink = function () {
        // default export options
        var widgetOptions = this.store.selectSnapshot(OrganizationsState.getWidgetOptions) || new WidgetOptions();
        this.store.dispatch(new GetPublishURL(this.bookmark, widgetOptions));
    };
    BookmarkActionsComponent.prototype.copyBookmark = function () {
        this.store.dispatch(new CopyBookmark(this.bookmarkId, this.bookmarkType));
    };
    return BookmarkActionsComponent;
}());
export { BookmarkActionsComponent };
